export enum LinkType {
  member = 'member',
  task = 'task',
  conversation = 'conversation',
  opportunity = 'opportunity',
  account = 'account',
  sale = 'sale',
  note = 'note',
  file = 'file',
  prospect = 'prospect',
}
